
import chargeImg from "../../assets/images/img-charge.png";
import evLogo from "../../assets/images/ev-logo-02.png";
import { SERVICES_LIST } from "../servicedata";
import { Link } from "react-router-dom";

const WhyUs = () => {
  return (
    <section className="why-us pt-10 position-relative z-1">
      <div className="overlay"></div>

      <div className="container position-relative">
        <div className="why-us-inner">

          {/* SECTION TITLE */}
          <div className="section-title mb-6 text-center text-md-start">
            <div className="row align-items-center gx-md-5">
              <div className="col-lg-7">
                <div className="section-title-left">
                  <h6 className="text-uppercase fw-medium green1 mb-1">
                    Why choose us
                  </h6>
                  <h2 className="ps-4 border-start border-3 border-green">
                    Best electric{" "}
                    <span className="green">service provider</span> for the
                    electric Connections
                  </h2>
                </div>
              </div>

              <div className="col-md-5">
                <div className="section-title-right">
                  <p className="mb-3">
                   Denial Enterprise provides turnkey electrical and infrastructure solutions tailored for multinational corporations. We bridge the gap between complex grid requirements and efficient charging operations, ensuring your fleet and facilities are always powered.
                  </p>
               
                   <Link to="/services" className="btn btn1 bg-darkgreen text-white">
                                            More Services
                                        </Link>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION BODY */}
          <div className="section-body">
            <div className="row gy-5 align-items-end">

              {/* LEFT SERVICES */}
              <div className="col-xl-8">
                <div className="section-body-left pb-lg-5 mb-lg-5">
                  <div className="row gy-4 gx-md-4">

                    {SERVICES_LIST.slice(0, 6).map((item, index) => (
                      <div className="col-md-6 d-flex" key={index}>
                        <div className="service-box d-flex align-items-center p-6 border border-2 bg-white border-lightgreen rounded2">
                          <div className=" me-4">
                            <img src={item.icon} className="w-100" alt={item.title} />
                          </div>
                          <div className="service-info">
                            <h4 className="mb-1">
                              <Link to={item.path} className="black">
                                {item.title}
                              </Link>
                            </h4>
                            <p>
                              {item.desc}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
              </div>

              {/* RIGHT IMAGE */}
              <div className="col-xl-4">
                <div className="section-body-right position-relative">
                  <div className="service-image text-center">
                    <img src={chargeImg} alt="service" className="w-100" />
                  </div>

                  <div className="ev-logo p-2 bg-white border border-3 border-grey1 rounded-circle text-center position-absolute">
                    <img src={evLogo} alt="EV Logo" />
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyUs;
